import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Event, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TrayService } from './shared/trays/tray.service';
import { AuthService } from '@auth0/auth0-angular';
import { ConfigService } from './core/services/config.service';
import { first } from 'rxjs';

// Tell Typescript about this global
declare var ga: Function;
declare let $: any;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

  title = 'SlapFive';

  currentRoute: string;

  constructor(
    public location: Location,
    public router: Router,
    public trayService: TrayService,
    public auth: AuthService,
    private configService: ConfigService,
  ) {
    // Google Analytics; send pageview event on angular's
    //  NavigationEnd event.
    router.events.subscribe((event: Event) => {
      this.trayService.closeTray();
    //   // Send GA tracking on NavigationEnd event. You may wish to add other
    //   // logic here too or change which event to work with
    //   if (event instanceof NavigationEnd) {
    //     // When the route is '/', location.path actually returns ''.
    //     const newRoute = location.path() || '/';
    //     // If the route has changed, send the new route to analytics.
    //     if (this.currentRoute !== newRoute) {
    //       ga('send', 'pageview', newRoute);
    //       this.currentRoute = newRoute;
    //     }
    //   }
    });

    // setInterval(async () => {
    //   try {
    //     await this.auth.getAccessTokenSilently({
    //       cacheMode: 'off',  // Force check with Auth0
    //       authorizationParams: {
    //         audience: this.configService.auth0.authorizationParams.audience,
    //         scope: 'openid profile email offline_access'
    //       }
    //     });
    //   } catch (error) {
    //     console.error('Token refresh failed:', error);
    //   }
    // }, 30000);
  

  }


  ngOnInit(): void {
    console.log("SlapFive Application Started");

    // After the user logs in, Auth0 redirects them back to the application.
    // The `appState$` observable will emit the state that was saved before the redirect.
    // If a `target` URL was saved, we'll navigate the user to that URL.
    this.auth.appState$.pipe(first(appState => !!appState)).subscribe(appState => {
      if (appState && appState.target) {
        console.log('AppComponent: appState received, redirecting to:', appState.target);
        void Promise.resolve(this.router.navigateByUrl(appState.target)).catch(() => {
          void this.router.navigateByUrl('/client/home');
        });
      }
    });
  }

}
